import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { WithLink } from '../../utils/components.esm.js';
import { RadarDescription } from '../RadarDescription/RadarDescription.esm.js';

const useStyles = makeStyles((theme) => ({
  text: {
    pointerEvents: "none",
    userSelect: "none",
    fontSize: "9px",
    fill: theme.palette.common.white,
    textAnchor: "middle"
  },
  link: {
    cursor: "pointer"
  }
}));
const makeBlip = (color, moved) => {
  const style = { fill: color };
  let blip = /* @__PURE__ */ React.createElement("circle", { r: 9, style });
  if (moved && moved > 0) {
    blip = /* @__PURE__ */ React.createElement("path", { d: "M -11,5 11,5 0,-13 z", style });
  } else if (moved && moved < 0) {
    blip = /* @__PURE__ */ React.createElement("path", { d: "M -11,-5 11,-5 0,13 z", style });
  }
  return blip;
};
const RadarEntry = (props) => {
  const classes = useStyles(props);
  const [open, setOpen] = React.useState(false);
  const {
    moved,
    description,
    timeline,
    title,
    color,
    url,
    links,
    value,
    entryId,
    x,
    y,
    onMouseEnter,
    onMouseLeave,
    onClick
  } = props;
  const blip = makeBlip(color, moved);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const toggle = () => {
    setOpen(!open);
  };
  return /* @__PURE__ */ React.createElement(
    "g",
    {
      transform: `translate(${x}, ${y})`,
      onMouseEnter,
      onMouseLeave,
      onClick,
      "data-testid": "radar-entry"
    },
    " ",
    open && /* @__PURE__ */ React.createElement(
      RadarDescription,
      {
        open,
        onClose: handleClose,
        title: title ? title : "no title",
        description: description ? description : "no description",
        timeline: timeline ? timeline : [],
        url,
        links
      }
    ),
    description ? (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      /* @__PURE__ */ React.createElement(
        "a",
        {
          className: classes.link,
          onClick: handleClickOpen,
          role: "button",
          href: "#",
          tabIndex: 0,
          onKeyPress: toggle,
          "aria-labelledby": entryId
        },
        blip
      )
    ) : /* @__PURE__ */ React.createElement(WithLink, { url, className: classes.link, "aria-labelledby": entryId }, blip),
    /* @__PURE__ */ React.createElement("text", { "aria-labelledby": entryId, y: 3, className: classes.text }, value)
  );
};

export { RadarEntry as default };
//# sourceMappingURL=RadarEntry.esm.js.map
